// extracted by mini-css-extract-plugin
module.exports = {"modalityTable":"ModalityList_modalityTable__1q7Oy"};